import { FormTemplateRule } from '../templating/formTemplateRule'
import { FormField, FormFieldType } from '../base/formField'
import { FormTemplateRuleParameter } from '../templating/formTemplateRuleParameter'
import { FormTemplateRuleParameterType } from '../templating/formTemplateRuleParameterType'

export class DuplicateRule extends FormTemplateRule {
  constructor () {
    const callback = function (submission, index, parameters) {
      const serialized = JSON.stringify(submission)
      const n = parameters.count
      let output = []
      for (var i = 0; i < n; i++) {
        output.push(JSON.parse(serialized))
      }
      return output
    }

    const parameters = [
      new FormTemplateRuleParameter({
        identifier: 'count',
        type: FormTemplateRuleParameterType.FORM_FIELD,
        source: new FormField({
          type: FormFieldType.NUMBER,
          identifier: 'count',
          label: 'How Many Times?',
          placeholder: 1,
          defaultValue: 1,
        }),
      }),
    ]

    super('Duplicate', callback, parameters, 'This rule duplicates what you fill in above.')
  }
}
